import React from 'react';
import { intlShape, FormattedMessage, injectIntl } from 'react-intl';
import { isConjunctiveField } from '@bibliocommons/utils-filter';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import FullScreenOverlay from '@bibliocommons/base-full-screen-overlay';
import CheckboxFilter from '../CheckboxFilter';
import LinkFilter from '../LinkFilter';
import './ExpandedFiltersOverlay.scss';

const propTypes = {
  activeFilters: React.PropTypes.object.isRequired,
  fieldId: React.PropTypes.string.isRequired,
  handleToggleExpandedField: React.PropTypes.func.isRequired,
  filters: React.PropTypes.object.isRequired,
  intl: intlShape,
  open: React.PropTypes.bool,
  label: React.PropTypes.string,
  handleClose: React.PropTypes.func.isRequired
};

class ExpandedFiltersOverlay extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderFilter');
  }

  renderFilter(filter) {
    let classString = 'filter';
    if (filter.get('applied')) {
      classString += ' applied';
    }

    const FilterTag = isConjunctiveField(this.props.fieldId) ? LinkFilter : CheckboxFilter;

    return (
      <div key={filter.get('value')} className={`${classString} col-sm-6 col-md-6`}>
        <div className="expanded-filter-label-wrap">
          <FilterTag
            fieldId={this.props.fieldId}
            filter={filter}
            handleToggleFilter={this.props.handleToggleExpandedField} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <FullScreenOverlay {...this.props} data-test-id={`${this.props.fieldId}-more-filters-overlay`}>
        <h1>
          <FormattedMessage
            id="expanded_filter_header"
            values={{ field: this.props.intl.formatMessage({ id: this.props.label || `${this.props.fieldId}.field` }) }} />
        </h1>
        <div className="expanded-filter-list">
          {this.props.filters.valueSeq().map(this.renderFilter)}
        </div>
      </FullScreenOverlay>
    );
  }
}

ExpandedFiltersOverlay.propTypes = propTypes;

export default injectIntl(ExpandedFiltersOverlay);



// WEBPACK FOOTER //
// ./app/components/shared/Facets/ExpandedFiltersOverlay/ExpandedFiltersOverlay.jsx